export default __webpack_public_path__ + "static/media/wife-and-cat-sm-2x.9dbafa5f.jpg";